document.addEventListener('DOMContentLoaded', function() {
    jQuery('#form-product-environments select[name="products"]').select2( { 
        language: {
            noResults:function() {
                return jQuery("#products_environment").data("no-results") 
            },
            searching:function() {
                return jQuery("#products_environment").data("searching") + '...'
            },
            inputTooShort:function() {
                return jQuery("#products_environment").data("inputshort")
            },
            loadMore:function() {
                return jQuery("#products_environment").data("more") + '...'
            }
        },
        ajax: {
            url:ajax_url,
            dataType:"json",
            data:function(e) {
                return {
                    search:e.term,
                    action:"get_products"
                }
            }
        },
        minimumInputLength:3,
        placeholder:"Procure por um produto"
    })

    jQuery('body').on('change','#products_environment',function(){
        var valor = jQuery(this).val();
        var nome  = jQuery('#products_environment option:selected').text();
        var lang  = jQuery('body').attr('data-lang');
        if(valor !== '#'){
            if(valor){
                var product = valor.split('|');
                jQuery(".loader").addClass("active");
                jQuery.ajax({
                    type: "POST",
                    data: { action: 'get_environments_by_product', product_environment: product[0], lang: lang },
                    url: ajax_url,
                    success: function (result) {
                        console.log(result);
                        jQuery(".main-environments-content-internal").addClass('d-none');
                        jQuery(".main-environments-content-external").addClass('d-none');
                        jQuery(".content-search-found h2 strong").html(nome);
                        jQuery(".content-search-found").removeClass('d-none');
                        jQuery(".itens-search-found").html(result);
                        jQuery(".loader").removeClass("active");
                    }
                });
            }else{ 
                jQuery(".main-environments-content-internal").removeClass('d-none');
                jQuery(".main-environments-content-external").removeClass('d-none');
                jQuery(".content-search-found h2 strong").html('');
                jQuery(".content-search-found").addClass('d-none');
                jQuery(".itens-search-found").html('');
            }
        } 

    })

    jQuery('body').on('click','#allEnvironments',function(){
        jQuery(".loader").addClass("active");
        setTimeout(function(){
            jQuery(".main-environments-content-internal").removeClass('d-none');
            jQuery(".main-environments-content-external").removeClass('d-none');
            jQuery(".content-search-found h2 strong").html('');
            jQuery(".content-search-found").addClass('d-none');
            jQuery(".itens-search-found").html('');
            jQuery(".loader").removeClass("active");
            jQuery('#form-product-environments select[name="products"]').select2("val", "#");
        }, 2000);
    })

})

function registrarDownload(tipo) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', ajax_url, true); 
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function() {
        if (xhr.status === 200) {
            //window.location.href = xhr.responseText; // Redireciona para o link do arquivo após registrar
            console.log(xhr.responseText);
        }
    };

    xhr.send('action=registrar_download&tipo=' + tipo);
}